import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useDispatch, useSelector} from 'react-redux'
import {freeCreditToUser} from '../UserProfileDetailSlice/UserProfileDetailSlice'
import {useUpdatePostPaidCreditLimitMutation} from '../../../../../../services/cellcast.v2'
import {toast} from 'react-toastify'

const LimitCreditModal = ({show, handleClose}: any) => {
  const UserProfileData = useSelector((state: any) => state?.ProfileData?.ProfileData?.user)
  const UserProfileCredit = useSelector((state: any) => state?.ProfileData?.ProfileData?.credits)

  const dispatch = useDispatch()

  const [updateCredit] = useUpdatePostPaidCreditLimitMutation()
  const [smsCredit, setSmsCredit] = useState<any>(0)
  const [mmsCredit, setMmsCredit] = useState<any>(0)

  // add credit to user
  const submitFreeCredit = () => {
    if (smsCredit && UserProfileCredit.sms < smsCredit) {

      dispatch(
        freeCreditToUser({
          userId: UserProfileData?._id,
          noOfCredit: smsCredit - UserProfileCredit.sms,
          campType: 'sms',
        })
      )
    }
    if (mmsCredit && UserProfileCredit.mms < mmsCredit) {
      dispatch(
        freeCreditToUser({
          userId: UserProfileData?._id,
          noOfCredit: mmsCredit - UserProfileCredit.mms,
          campType: 'mms',
        })
      )
    }
  }

  const submitUpdateCredit = () => {
    updateCredit({
      userId: UserProfileData?._id,
      smsLimitPerMonth: smsCredit,
      mmsLimitPerMonth: mmsCredit,
    })
      .unwrap()
      .then((res) => {
        submitFreeCredit()
        toast.success(res.message)
      })
      .catch((err) => {
        toast.error(err.message)
      })
      .finally(() => {
        handleClose()
      })
  }

  useEffect(() => {
    setSmsCredit(UserProfileData?.postPaidLimitConfig?.smsLimitPerMonth)
    setMmsCredit(UserProfileData?.postPaidLimitConfig?.mmsLimitPerMonth)
  }, [UserProfileData])

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header border-bottom'>
          <h2>Limit credits each month</h2>
          <div className='btn btn-icon btn-sm' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body p-20 '>
          <div className='row mb-2'>
            <div className='border-end pe-15'>
              <label className=' col-form-label fw-normal fs-6'></label>
              <div className='d-flex gap-4'>
                <div>
                  <label className='btn btn-light-info py-2 px-5' htmlFor='quick_sms_radio2'>
                    <span className='fw-500 fs-2'>SMS</span>
                  </label>

                  <div className='mt-2'>
                    <input
                      onChange={(e: any) => setSmsCredit(e.target.value)}
                      name='Type'
                      type='text'
                      value={smsCredit}
                      className='form-control form-control-lg form-control-solid mb-4 w-100 text-bg-light d-block'
                    />
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block text-danger'></div>
                    </div>
                  </div>
                </div>
                <div>
                  <label
                    className='btn btn-active-info btn-light-info py-2 px-5'
                    htmlFor='quick_mms_radio2'
                  >
                    <span className='fw-500 fs-2'>MMS</span>
                  </label>
                  <div className='mt-2'>
                    <input
                      onChange={(e: any) => setMmsCredit(e.target.value)}
                      name='Type'
                      type='text'
                      value={mmsCredit}
                      className='form-control form-control-lg form-control-solid mb-4 w-100 text-bg-light d-block'
                    />
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block text-danger'></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='d-flex flex-center mt-20'>
              <div id='kt_drawer_chat_close'>
                <button
                  type='button'
                  onClick={handleClose}
                  className='btn btn-light text-hover-white rounded btn-active-primary me-3 w-100px p-3 fw-500 me-2'
                >
                  Discard
                </button>
              </div>

              <button
                type='submit'
                className='btn btn-light btn-primary fw-500 rounded  w-100px p-3 border border-primary'
                onClick={submitUpdateCredit}
              >
                <span className='indicator-label'>Submit</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default LimitCreditModal
